/**
 * `EmptyState` — stato vuoto uniforme (nessun dato). Presentazionale; passare
 * `role="status"` quando lo stato vuoto è il risultato di un caricamento.
 *
 * Componente unico usato in tutte le pagine per gli stati "nessun dato": non
 * mostra icone, così da restare coerente ovunque. Accetta un `title` opzionale
 * (enfatizzato) e il messaggio come `children`.
 */
import type { ReactNode } from 'react';

interface EmptyStateProps {
  title?: ReactNode;
  children?: ReactNode;
  role?: 'status';
}

export function EmptyState({ title, children, role }: EmptyStateProps) {
  return (
    <div className="ui-empty" role={role}>
      {title && <strong>{title}</strong>}
      {children && <span>{children}</span>}
    </div>
  );
}
